const error = {
  convertToUserFriendlyErrorMessage(e) {
    if (/^.*( validation failed)$/.test(e)) {
      return 'Error: Missing required fields. Please fill out all required fields and try again.';
    } if (e === 'fullName Must enter a full name') {
      return 'Error: Missing full name. Please fill out full name and try again.';
    } if (e === 'email Must have an email address') {
      return 'Error: Missing email address. Please fill out email address and try again.';
    } if (e === 'birthdate Must enter a birthdate') {
      return 'Error: Missing birthdate. Please fill out birthdate and try again.';
    } if (/(E11000 duplicate key error index: hydra\.driver_ratings_user_profile\.\$email_1 dup key).*$/.test(e)) {
      return 'Error: Duplicate email. Please use a different email address.';
    } if (e === 'mobileNumber Must have a phone number') {
      return 'Error: Missing primary phone. Please fill out primary phone and try again.';
    } if (e === 'submitterName Must have a submitter name') {
      return 'Error: Missing submitter name. Please fill out submitter name and try again.';
    } if (e === 'driverName Must have a driver name') {
      return 'Error: Missing driver name. Please fill out driver name and try again.';
    } if (e === 'series Must have a series') {
      return 'Error: Missing series. Please fill out series and try again.';
    } if (e === 'track Must have a track') {
      return 'Error: Missing track. Please fill out track and try again.';
    } if (e === 'date Must have a date') {
      return 'Error: Missing date. Please fill out date and try again.';
    } if (e === 'Unexpected token E in JSON at position 0') {
      return 'Something went wrong. Please contact Trent at trent.rodriguez@toyota.com.';
    }
    return 'Error submitting. Please contact Trent at trent.rodriguez@toyota.com.';
  },
};

export default error;
